<ng-container [formGroup]="settings.form">
  <pk-date-field [settings]="settings" [formControlName]="settings.formControlName"></pk-date-field>
</ng-container>
